import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { login } from "../Service/UserService";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate for redirection
import { FcGoogle } from "react-icons/fc";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { loginUser } from "../store/userSlice";
import { FaRegEye,FaRegEyeSlash  } from "react-icons/fa";


const Login = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate(); // ✅ Initialize useNavigate
  const dispatch =useDispatch()

  useEffect(() => {
    const token = Cookies.get("access_token");
    if (token) {
      navigate("/"); // Redirect if already logged in
    }
  }, [navigate]);

  // Validation Schema
  const validationSchema = Yup.object({
    name: isSignup ? Yup.string().required("Name is required") : Yup.string(),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  // Handle Form Submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setMessage("");
    try {
      const url = isSignup ? "/register" : "/login";
      const data = await login(url, values);
      console.log(data);
      setMessage(data.message);
      resetForm(); // ✅ Reset form fields after successful login/signup

      setTimeout(() => {
        setMessage("");
        if (isSignup) {
          setIsSignup(false);
          Cookies.set("access_token", data.tokens.access_token, { expires: 1 }); // Expires in 1 day
          Cookies.set("user", JSON.stringify(data.user), { expires: 1 });
          // navigate("/edit_profile", { state: { fromSignup: true } });
          navigate("/edit_profile");
          Cookies.set("signup_profile",true)
        } else {
          // Store tokens in cookies
          Cookies.set("access_token", data.tokens.access_token, { expires: 1 }); // Expires in 1 day
          Cookies.set("user", JSON.stringify(data.user), { expires: 1 });
          // dispatch(loginUser(data.user))
          

          navigate("/");
        }
      }, 1000);
    } catch (error) {
      setMessage(error.response?.data?.error || "Something went wrong!");
    }
    setSubmitting(false);
  };

  return (

    <div className="h-screen w-screen bg-black flex items-center justify-center relative overflow-hidden">
      {/* Background Gradient Effects */}
      <div className="absolute h-[300px] w-[300px] bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-3xl top-10 left-20 animate-pulse"></div>
      <div className="absolute h-[250px] w-[250px] bg-gradient-to-r from-pink-500 to-red-500 rounded-full blur-3xl bottom-10 right-20 animate-pulse"></div>

      {/* Login Box */}
      <div className="relative bg-gray-900 text-white p-10 rounded-xl shadow-xl w-96 border border-gray-700 backdrop-blur-md">
        <h2 className="text-2xl font-semibold text-center mb-4">
          {isSignup ? "Sign Up" : "Login"}
        </h2>

        {/* Formik Form */}
        <Formik
          initialValues={{ name: "", email: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="flex flex-col space-y-4">
              {isSignup && (
                <div>
                  <Field
                    type="text"
                    name="name"
                    placeholder="Name"
                    className="p-3 bg-gray-800 rounded-md border border-gray-600 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <ErrorMessage
                    name="name"
                    component="p"
                    className="text-red-500 text-sm"
                  />
                </div>
              )}

              <div>
                <Field
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="p-3 bg-gray-800 rounded-md border border-gray-600 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ErrorMessage
                  name="email"
                  component="p"
                  className="text-red-500 text-sm"
                />
              </div>

              <div className="relative">
                <Field
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  className="p-3 bg-gray-800 rounded-md border border-gray-600 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  type="button"
                  className="absolute right-3 top-4 text-gray-400 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {/* {showPassword ? "🙈" : "👁️"} */}

                  {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </button>
                <ErrorMessage
                  name="password"
                  component="p"
                  className="text-red-500 text-sm"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="p-3 bg-white text-black rounded-md hover:bg-gray-300 disabled:bg-gray-600"
              >
                {isSubmitting
                  ? "Processing..."
                  : isSignup
                  ? "SIGN UP NOW"
                  : "LOGIN"}
              </button>
            </Form>
          )}
        </Formik>

        {/* Success / Error Message */}
        {message && (
          <p className="text-center text-green-400 mt-4">{message}</p>
        )}

        <div className="text-center text-gray-400 mt-4">
          Or
          {/* Or {isSignup ? "sign up" : "login"} with */}
        </div>

        {/* Google Signup Button */}
        <button className="mt-3 flex items-center justify-center space-x-2 p-3 border border-gray-600 rounded-md hover:border-blue-500 w-full">
          <FcGoogle size={24} />
          <span>{isSignup ? "Sign up" : "Login"} with Google</span>
        </button>

        {/* Toggle between Login and Signup */}
        <div className="text-center mt-4">
          <button
            onClick={() => setIsSignup(!isSignup)}
            className="text-blue-400 hover:underline"
          >
            {isSignup
              ? "Already have an account? Login"
              : "Don't have an account? Sign Up"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
